var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWhiteArrow = function SvgWhiteArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.775 6.094h12.35M9.928 1.748 14.225 6l-4.297 4.252",
    stroke: "#fff",
    strokeWidth: 1.507,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};

export { SvgWhiteArrow as ReactComponent };
export default __webpack_public_path__ + "f1cface3a318df301d427a7483386d95.svg";